/* eslint-disable no-nested-ternary */
import {
  areas,
  formatCurrency,
  formatShares,
  investmentInstruments,
  listingTypes,
  sectors,
  offerTypes,
  fundTypes,
  geographicMandates,
  baseCurrencies,
  domicileOnshoreFund,
  systematicDiscretionaryOptions,
  investmentAdvisorTypes,
  investmentCoActExemptionOptions,
} from 'entoro-shared';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const formatAllCurrency = (value, currency = 'USD') => {
  // Validate currency code
  const currencyCodes = new Set(Intl.supportedValuesOf('currency'));
  const validCurrencyCode = currencyCodes.has(currency) ? currency : 'USD';

  // Format the value with respect to the specified currency
  const currencySymbols = Array.from(currencyCodes)
    .map((currencyCode) => {
      try {
        return Intl.NumberFormat('en', {
          style: 'currency',
          currency: currencyCode,
        })
          .formatToParts(0)
          .find((part) => part.type === 'currency');
      } catch (error) {
        return undefined;
      }
    })
    .filter((currencySymbol) => currencySymbol !== undefined);

  const currencySymbol = currencySymbols.find(
    (symbol) => symbol !== undefined && symbol.unit === validCurrencyCode
  );

  const formattedValue = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: validCurrencyCode,
    currencyDisplay: 'symbol',
    currencySign: 'accounting',
    ...(currencySymbol && { currencyDisplay: 'code' }),
  }).format(value);

  return formattedValue;
};
const OfferDetailsFund = ({
  offer: {
    listingType,
    minimumInvestment,
    targetRaise,
    offerCurrency,
    valueRange,
    assetStatus,
    sharesForSale,
    amountRaise,
    totalInvestors,
    netAcres,
    averageDailyProduction,
    typeOfOffer,
    headerType,
    closingDate,
    countDown,
    baseCurrency,
    geographicMandate,
    fundType,
    domicileOption,
    domicileOnshore,
    domicileOffShore_other,
    domicileOffShore,
    systematicDiscretionaryOption,
    investmentCoActExemptionOption,
    investmentAdvisorType,
    leverage,
    domicileOnshoreFund_other,
    fundStrategyClassfication,
    fundStrategyClassficationOne,
    fundStrategyClassficationTwo,
    fundStrategyClassficationThree,
    aumfund,
    fundCapacity,
    trackRecordFund,
    trackRecordFirm,
  },
  disabledRepublic,
  OfferName,
  CompanyName,
}) => {
  const date = moment(countDown).format('YYYY-MM-DD');
  const Closingday = moment(closingDate).format('YYYY-MM-DD');
  const difference = +new Date(`${date}`) - +new Date();
  const openInvestmentHour = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const openInvestmentDay = Math.floor(difference / (1000 * 60 * 60 * 24));
  return (
    <div>
      <div className='w-row'>
        <div className='column-2 w-col w-col-8'>
          <div className='header-container'>
            {headerType === 'VIDEO' && (
              <Fragment>
                <div className='_16-black-label'>Company&nbsp;Name</div>
                <div
                  className='black-44'
                  style={{ fontWeight: 'normal' }}
                >{`${CompanyName}`}</div>
              </Fragment>
            )}
            {headerType === 'IMAGE' ? (
              <div className='black-44'>{`${OfferName}`} Details</div>
            ) : (
              <div className='black-44' style={{ fontSize: '35px' }}>
                {`${OfferName}`} Details
              </div>
            )}

            {typeOfOffer && !difference && (
              <Fragment>
                <div className='_16-black-label'>Type&nbsp;Of&nbsp;Offer</div>
                <div className='_26-black'>
                  {offerTypes.getLabel(typeOfOffer)}
                </div>
              </Fragment>
            )}
            {typeOfOffer && difference > 0 && (
              <Fragment>
                <div className='_16-black-label'>Type&nbsp;Of&nbsp;Offer</div>
                <div className='_26-black'>
                  {offerTypes.getLabel(typeOfOffer)}
                </div>
              </Fragment>
            )}
          </div>
          {!disabledRepublic && (
            <Fragment>
              {typeOfOffer === 'REG_CF' && (
                <div className='detail-columns w-row'>
                  <div className='w-col w-col-6'>
                    {typeOfOffer === 'REG_CF' && (
                      <Fragment>
                        {difference > 0 && (
                          <Fragment>
                            {' '}
                            <div className='_16-black-label'>
                              Accepting Investment in
                            </div>
                            <div className='_26-black'>
                              {openInvestmentDay !== 0
                                ? ` ${openInvestmentDay} Days`
                                : ` ${openInvestmentHour} Hours`}
                            </div>
                          </Fragment>
                        )}
                        {typeOfOffer && difference < 0 && (
                          <Fragment>
                            <div className='_16-black-label'>
                              Type&nbsp;Of&nbsp;Offer
                            </div>
                            <div className='_26-black'>
                              {offerTypes.getLabel(typeOfOffer)}
                            </div>
                          </Fragment>
                        )}
                      </Fragment>
                    )}
                  </div>
                  <div className='w-col w-col-6'>
                    {typeOfOffer === 'REG_CF' && Closingday && (
                      <Fragment>
                        <div className='_16-black-label'> Closing Date</div>
                        <div className='_26-black'>{Closingday}</div>
                      </Fragment>
                    )}
                  </div>
                </div>
              )}
              <div className='detail-columns w-row'>
                <div className='w-col w-col-6'>
                  {typeOfOffer === 'REG_CF' && (
                    <Fragment>
                      <div className='_16-black-label'>Amount Raised</div>
                      <div className='_26-black'>
                        {formatAllCurrency(amountRaise, offerCurrency) || 'N/A'}
                      </div>
                    </Fragment>
                  )}
                </div>
                <div className='w-col w-col-6'>
                  {typeOfOffer === 'REG_CF' && (
                    <Fragment>
                      <div className='_16-black-label'>Total Investors</div>
                      <div className='_26-black'>{totalInvestors}</div>
                    </Fragment>
                  )}
                </div>
              </div>
            </Fragment>
          )}
          <div className='detail-columns w-row'>
            <div className='w-col w-col-6'>
              {listingType === 'SECONDARY_SALES' && (
                <Fragment>
                  <div className='_16-black-label'>
                    Shares&nbsp;for&nbsp;Sale
                  </div>
                  <div className='_26-black'>{formatShares(sharesForSale)}</div>
                </Fragment>
              )}
              {listingType === 'ACQUISITIONS_AND_DIVESTITURES' && (
                <Fragment>
                  <div className='_16-black-label'>
                    Average&nbsp;Daily&nbsp;Production
                  </div>
                  <div className='_26-black'>{averageDailyProduction}</div>
                </Fragment>
              )}
              {listingType === 'ASSET_SALES' && (
                <Fragment>
                  <div className='_16-black-label'>Value&nbsp;Range</div>
                  <div className='_26-black'>{valueRange}</div>
                </Fragment>
              )}
              {listingType !== 'SECONDARY_SALES' &&
                listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
                listingType !== 'ASSET_SALES' && (
                  <Fragment>
                    <div className='_16-black-label'>
                      Target&nbsp;Investment
                    </div>
                    <div className='_26-black'>
                      {formatAllCurrency(targetRaise, offerCurrency)}
                    </div>
                  </Fragment>
                )}
            </div>
            <div className='w-col w-col-6'>
              {listingType === 'ACQUISITIONS_AND_DIVESTITURES' && (
                <Fragment>
                  <div className='_16-black-label'>Net&nbsp;Acres</div>
                  <div className='_26-black'>
                    {formatShares(netAcres) || 'N/A'}
                  </div>
                </Fragment>
              )}
              {listingType === 'ASSET_SALES' && (
                <Fragment>
                  <div className='_16-black-label'>Asset&nbsp;Status</div>
                  <div className='_26-black'>{assetStatus}</div>
                </Fragment>
              )}
              {listingType !== 'ACQUISITIONS_AND_DIVESTITURES' &&
                listingType !== 'ASSET_SALES' && (
                  <Fragment>
                    <div className='_16-black-label'>
                      Minimum&nbsp;Investment
                    </div>
                    <div className='_26-black'>
                      {formatAllCurrency(minimumInvestment, offerCurrency) ||
                        'N/A'}
                    </div>
                  </Fragment>
                )}
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-6'>
              <div className='_16-black-label'>Listing Type</div>
              <div className='_26-black'>
                {listingTypes.getLabel(listingType)}
              </div>
            </div>
            <div className='w-col w-col-6'>
              <Fragment>
                <div className='_16-black-label'>Fund Type</div>
                <div className='_26-black'>{fundTypes.getLabel(fundType)}</div>
              </Fragment>
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-6'>
              <div className='_16-black-label'>Geographic Mandate</div>

              {geographicMandate.map((v, i) => (
                <div key={i} className='_26-black'>
                  {'•'} {geographicMandates.getLabel(geographicMandate[i])}
                </div>
              ))}
            </div>
            <div className='w-col w-col-6'>
              <Fragment>
                <div className='_16-black-label'>Base Currency</div>
                <div className='_26-black'>
                  {baseCurrencies.getLabel(baseCurrency)}
                </div>
              </Fragment>
            </div>
          </div>

          <div className='detail-columns w-row'>
            <div className='w-col w-col-6'>
              {domicileOption === 'ONSHORE_FUND' ? (
                <Fragment>
                  <div className='_16-black-label'>Domicile Onshore</div>
                  <div className='_26-black'>
                    {domicileOnshoreFund.getLabel(domicileOnshore) == 'Other'
                      ? domicileOnshoreFund_other
                      : domicileOnshoreFund.getLabel(domicileOnshore)}
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <div className='_16-black-label'>Domicile Offshore</div>
                  <div className='_26-black'>
                    {domicileOnshoreFund.getLabel(domicileOffShore) == 'Other'
                      ? domicileOffShore_other
                      : domicileOnshoreFund.getLabel(domicileOffShore)}
                  </div>
                </Fragment>
              )}
            </div>
            <div className='w-col w-col-6'>
              <Fragment>
                <div className='_16-black-label'>
                  Systematic or Discretionary
                </div>
                <div className='_26-black'>
                  {systematicDiscretionaryOptions.getLabel(
                    systematicDiscretionaryOption
                  )}
                </div>
              </Fragment>
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-12'>
              <div className='_16-black-label'>Fund Investment Strategy</div>
              <div className='_26-black'>{fundStrategyClassfication}</div>
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-12'>
              <div className='_16-black-label'>
                Fund Strategy Classification
              </div>
              <div className='_16-black-label'>Strategy #1</div>
              <div className='_26-black'>{fundStrategyClassficationOne}</div>
              <div className='_16-black-label'>Strategy #2</div>
              <div className='_26-black'>{fundStrategyClassficationTwo}</div>
              <div className='_16-black-label'>Strategy #3</div>
              <div className='_26-black'>{fundStrategyClassficationThree}</div>
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-6'>
              <div className='_16-black-label'>
                Investment Co. Act of 1940 Exemption
              </div>
              <div className='_26-black'>
                {}
                {investmentCoActExemptionOptions.getLabel(
                  investmentCoActExemptionOption
                )}
              </div>
            </div>
            <div className='w-col w-col-6'>
              <Fragment>
                <div className='_16-black-label'>Investment advisor type</div>
                <div className='_26-black'>
                  {investmentAdvisorTypes.getLabel(investmentAdvisorType)}
                </div>
              </Fragment>
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-6'>
              <Fragment>
                <div className='_16-black-label'>
                  AUM MANAGER ({offerCurrency})
                </div>
                <div className='_26-black'>
                  {formatAllCurrency(aumfund, offerCurrency)}
                </div>
              </Fragment>
            </div>
            <div className='w-col w-col-6'>
              <Fragment>
                <div className='_16-black-label'>
                  FUND CAPACITY ({offerCurrency})
                </div>
                <div className='_26-black'>
                  {formatAllCurrency(fundCapacity, offerCurrency)}
                </div>
              </Fragment>
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-6'>
              <div className='_16-black-label'>Track Record Fund Mos</div>
              <div className='_26-black'>{trackRecordFund}</div>
            </div>
            <div className='w-col w-col-6'>
              <Fragment>
                <div className='_16-black-label'>Track Record Firm Mos</div>
                <div className='_26-black'>{trackRecordFirm}</div>
              </Fragment>
            </div>
          </div>
          <div className='detail-columns w-row'>
            <div className='w-col w-col-12'>
              <Fragment>
                <div className='_16-black-label'>Use of Leverage</div>
                <div className='_26-black'>{leverage ? 'Yes' : 'No'}</div>
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

OfferDetailsFund.propTypes = {
  offer: PropTypes.object.isRequired,
};

export default OfferDetailsFund;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferDetailsFund.js